import React, {useState, useRef, useEffect} from 'react';
import propTypes from 'prop-types';
import ReCAPTCHA from "react-google-recaptcha";
import {useForm, Controller} from "react-hook-form";
import styled from '@emotion/styled';
import {get} from 'lodash';
import {Grid, Box, TextField, RadioGroup, FormControlLabel} from '@mui/material';
import isEmail from 'validator/lib/isEmail';
import axios from 'axios';
import Router from 'next/router';
import { v4 as uuidv4 } from 'uuid';

import {theme} from '../../../themes/default-theme';
import Checkbox from '../../../components/forms/Checkbox';
import Topo from '../../../../src/assets/topo-block-blue-small.png'
import Radio from '../../../components/forms/Radio';
import FileUpload from '../../../components/forms/FileUpload';

import Button from '../../../components/ui/Cta';
import Text from '../../../components/typography';

const FormWrapper = styled.div `
  background: ${theme.palette.skyGradientLight};
  padding: 20px 16px;
  position: relative;

  ${theme.breakpoints.up('md')} {
    padding: 60px 15px 60px;

    &:before {
      content: ' ';
      display: block;
      width: 345px;
      height: 224px;
      background-image: url(${Topo});
      position: absolute;
      background-size: 100% auto;
      left: 0;
      right: 0;
      margin: auto;
      z-index: -1;
      top: 0;
      transform: translateX(-190px);
    }
  }
`

const Container = styled.div`
  background-color: ${theme.palette.white};
  max-width: 570px;
  margin: 0 auto;
  padding: 20px 16px;
  border-bottom-left-radius: 30px;

  ${theme.breakpoints.up('md')} {
    padding: 52px 58px;
    border-bottom-left-radius: 60px;
  }
`

const FormItem = styled.div`
  display: block;
  padding: 0 16px;
  text-align: left;
  margin:${props => props.smallMargin === true ? `15px 0` : `30px 0`};
  ${props => props.marginTop === false && `margin-top: 0;`}

  ${theme.breakpoints.down('md')} {
    ${props => props.col === true && `margin-top: 0;`}
    ${props => props.marginBottomSmall === false && `margin-bottom: 0;`}
  }

  ${theme.breakpoints.up('md')} {
    ${props => props.col === true && `margin: 0;`}
    ${props => props.marginTop === false && `margin-top: 0;`}
  }
`

const Footer = styled.div`
  padding: 0 16px 30px 16px;
`

const Error = styled.p`
  color: ${theme.palette.error.form}
`

const Hr = styled.hr`
  border-bottom: 1px solid ${theme.palette.middleGrey};
  border-top: 0;
`

const CustomRadioGroup = styled(RadioGroup) `
  ${props => props.inline === 1 && `
    flex-direction: row;
  `};
`

const TradeIn = (props) => {
  const [sending, setSending] = useState(false);
  const [error, setError] = useState(null);
  const [captchaError, setCaptchaError] = useState(null);
  const defaultValues = {};
  const [googleCaptcha, setGoogleCaptcha] = useState(false);
  const country = get(props, 'countryProps.countryCode', 'AU')
  const uniqueId = uuidv4();

  const { register, handleSubmit, watch, errors, control, formState, setFormState } = useForm({
    defaultValues
  });

  const formProps = useForm();

  // const handleChange = async (e) => {
  //   console.log('field', e);
  //   if (Object.keys(formProps.errors).length > 0) {
  //     await formProps.triggerValidation();
  //   }
  //   setFormState(formProps.getValues());
  // }


  const onSubmit = data => {

    const recaptchaValue = recaptchaRef.current.getValue();

    // formItems.forEach(item => {
    //   if (item.type === 'select') {
    //     refatorDropdowns[item.name] = data[item.name] && data[item.name].value ? data[item.name].value : undefined
    //   }
    // });

    const dealerId = process.env.DEALER_SITE && window.staticly.dealerData.id ? {
      dealer: window.staticly.dealerData.id
    } : {}

    const formData = {
      ...data,
      'g-recaptcha-response': googleCaptcha,
      form_id: 'trade_in',
      ...formProps.getValues(),
      ...dealerId
    }

    // console.log('formData', formData);
    // console.log('data', data);

    let bodyFormData = new FormData();
    let formattedData = {};
    Object.keys(formData).forEach(key => {
      if (typeof formData[key] === 'object' && !formData[key].value && formData[key].length > 0) {
        // For file upload
        formattedData[key] = [];
        for(var i = 0; i < formData[key].length; i++){
          let item = formData[key][i];
          bodyFormData.append('files[' + i + ']', item.file);
          formattedData[key].push({
            path: item.file
          });
        }
      } else {
        formattedData[key] = formData[key].toString() || '';
        formData[key] && bodyFormData.append(key, formData[key].toString() || '');
      }
    })

    // console.log('formattedData', formattedData);
    // return;

    if (googleCaptcha && recaptchaValue.length > 0 && Object.keys(errors).length === 0) {
      setCaptchaError(null);

      const endpoint = process.env.STATICLY_FORMS_API_ENDPOINT;

      setSending(true);

      const thankYouUrl = '/trade-in/thank-you'

      // axios.post(endpoint, formData)
      axios({
        method: 'post',
        url: endpoint,
        data: bodyFormData,
        headers: {'Content-Type': 'multipart/form-data'}
      })
      .then((response) => {
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
        process.env.NODE_ENV === 'development' || process.env.DEALER_SITE ?
          window.location.href = thankYouUrl
        :
        Router.push(thankYouUrl);
      })
      .catch((error) => {
        console.log('Form error: ', error);
        setError('Something went wrong. Please try again later.');
        setSending(false);
      });

    } else {
      setCaptchaError('Google captcha not complete');
      setSending(false)
    }
  }
  const recaptchaRef = useRef();

  const requiredRules = {required: true}

  const dealerTitle = typeof window !== 'undefined' && process.env.DEALER_SITE ? window.staticly.dealerData.name : "{{data.template.dealer.name}}"

  return (
    <FormWrapper>
      <Container>
        <form id={'trade_in'} noValidate autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
          <FormItem marginTop={false}>
            <Text variant="h4" align="center" colour="charcoal" uppercase>Enter Details</Text>
          </FormItem>
          <FormItem>
            <Controller
              as={TextField}
              control={control}
              rules={requiredRules}
              name={'first_name'}
              placeholder={'First Name*'}
              variant="outlined"
              error={ get(errors, `[first_name]`, false) ? true : false}
              fullWidth
              defaultValue={''}
            />
            {get(errors, `[first_name]`, false) && <Error>Please enter your first name</Error>}
          </FormItem>
          <FormItem>
            <Controller
              as={TextField}
              control={control}
              rules={requiredRules}
              name={'last_name'}
              placeholder={'Last Name*'}
              variant="outlined"
              error={ get(errors, `[last_name]`, false) ? true : false}
              fullWidth
              defaultValue={''}
            />
            {get(errors, `[last_name]`, false) && <Error>Please enter your last name</Error>}
          </FormItem>
          <FormItem>
            <Controller
              type="email"
              as={TextField}
              control={control}
              rules={{
                ...requiredRules,
                type: 'custom',
                validate: (e) => isEmail(e)
              }}
              name={'email'}
              placeholder={'Email*'}
              variant="outlined"
              error={get(errors, `[email]`, false) ? true : false}
              fullWidth
              defaultValue={''}
            />
            {get(errors, `[email]`, false) && <Error>Please enter a valid email</Error>}
          </FormItem>
          <FormItem>
            <Controller
              type="tel"
              as={TextField}
              control={control}
              rules={{
                ...requiredRules,
                type: 'custom',
                minLength: 8,
                maxLength: 13
              }}
              name={'phone'}
              placeholder={'Contact number*'}
              variant="outlined"
              error={get(errors, `[phone]`, false) ? true : false}
              fullWidth
              defaultValue={''}
            />
            {get(errors, `[phone]`, false) && <Error>Please enter a valid phone number</Error>}
          </FormItem>
          <FormItem margin={undefined} >
            <Text variant="subTitle" uppercase colour='black'  weight={'700'}>Finance Owing?</Text>
            <Controller
              control={control}
              rules={{
                ...requiredRules,
                type: 'custom'
              }}
              name={'finance'}
              label={'Finance Owing'}
              as={
                <CustomRadioGroup
                  defaultValue={undefined}
                  aria-label={'Finance Owing'}
                  name={'Finance Owing'}
                  inline={1}
                  onChange={(event) => console.log('Radio val', event.target.value)}
                >
                <FormControlLabel value={'yes'} control={
                  <Radio 
                    value={'yes'}
                    error={get(errors, `[finance]`, false) ? true : false}
                  />
                } label={'Yes'} />
                  <FormControlLabel value={'no'} control={
                    <Radio 
                      value={'no'}
                      error={get(errors, `[finance]`, false) ? true : false}
                    />
                  } label={'No'} />
                </CustomRadioGroup>
              }
            />
            {get(errors, `[finance]`, false) && <Error>Please select yes or no</Error>}
          </FormItem>
          <FormItem>
            <Controller
              as={TextField}
              control={control}
              rules={requiredRules}
              name={'value'}
              placeholder={'Estimated Value*'}
              variant="outlined"
              error={ get(errors, `[value]`, false) ? true : false}
              fullWidth
              defaultValue={''}
            />
            {get(errors, `[value]`, false) && <Error>Please enter the estimated value</Error>}
          </FormItem>
          <FormItem>
            <Controller
              as={TextField}
              control={control}
              rules={requiredRules}
              name={'make'}
              placeholder={'Make & Model*'}
              variant="outlined"
              error={ get(errors, `[make]`, false) ? true : false}
              fullWidth
              defaultValue={''}
            />
            {get(errors, `[make]`, false) && <Error>Please enter the make and model</Error>}
          </FormItem>
          <FormItem>
            <Controller
              as={TextField}
              control={control}
              rules={requiredRules}
              name={'year'}
              placeholder={'Model Year*'}
              variant="outlined"
              error={ get(errors, `[year]`, false) ? true : false}
              fullWidth
              defaultValue={''}
            />
            {get(errors, `[year]`, false) && <Error>Please enter the model year</Error>}
          </FormItem>
          <FormItem>
            <Text variant="subTitle" uppercase colour='black' weight={'700'}>Upload images of your van (max 6)</Text>
            <Controller
              as={
                <FileUpload 
                  defaultValue={undefined}
                  basicUi={true}
                  // individualS3Upload={true}
                  uploadProps={{
                    accept: '.jpg,.jpeg,.png,', // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#accept
                    multiple: false,
                    maxSize: '1000000', //1mb
                  }}
                  acceptableText={'Acceptable file formats: jpg, png'}
                  maxFileText={'Max file size: 1mb'}
                  maxFiles={6}
                  label={null}
                  uniqueId={uniqueId}
                />
              }
              control={control}
              rules={{
                type: 'custom'
              }}
              name='files'
            />
          </FormItem>
          <FormItem smallMargin={true}>
            <Controller
              as={Checkbox}
              name={'e_newsletter'}
              type="checkbox"
              control={control}
              defaultValue={false}
              label={`Sign me up for ${process.env.DEALER_SITE ? `${dealerTitle}'s` : `Jayco ${country}`} e-Newsletter`}
              rules={{
                type: 'custom'
              }}
            />
            <br />

            <Controller
              as={Checkbox}
              name="privacy"
              type="checkbox"
              control={control}
              label={`I have read and agree to ${process.env.DEALER_SITE ? `${dealerTitle}'s` : `Jayco ${country}`} <a href="/privacy" target="_blank">Privacy Policy</a>*`}
              error={ get(errors, `[privacy]`, false) ? true : false}
              defaultValue={false}
              rules={{
                ...requiredRules,
                type: 'custom'
              }}
            />
            {get(errors, `[privacy]`, false) && <Error>This field is required</Error>}
          </FormItem>
          <FormItem>
            <ReCAPTCHA
              ref={recaptchaRef}
              sitekey={process.env.GOOGLE_RECAPTCHA_SITE_KEY}
              onChange={setGoogleCaptcha}
            />
            {!googleCaptcha && captchaError &&
              <Error>{captchaError}</Error>
            }
            {error &&
              <Error>{error}</Error>
            }
          </FormItem>
          <FormItem>
            <Hr />
          </FormItem>
          <Footer>
          
              <Grid container direction={'row'} justifyContent={'space-between'} alignItems={'flex-start'}>
                <Grid size={6}>
                  <Text variant="body2">Mandatory*</Text>
                </Grid>
                <Grid align={'right'} size={6}>
                  <Button inline type="submit">{sending ? 'Submitting...'  : 'Submit'}</Button>
                </Grid>
              </Grid>
      
          </Footer>
        </form>
      </Container>
    </FormWrapper>
  );
}

TradeIn.propTypes = {
}

export default TradeIn